// extracted by mini-css-extract-plugin
module.exports = {"month-icon-container":"MonthIcon_month-icon-container__2VpK3","month-icon-month":"MonthIcon_month-icon-month__3ZBPx","month-icon-day":"MonthIcon_month-icon-day__RnzN3"};